import { memo } from 'react';
import { Grid, Stack, Text, VStack } from '@chakra-ui/react';

import ControllerInput from 'shared/ControllerInput';
import InterText from 'shared/InterText';

const ContactFormSection = ({
  title,
  isTitleNoteVisible = false,
  gridContainerProps = null,
  inputsData,
  control,
  trigger,
}) => (
  <VStack w="full" align="start" gap={{ mobile: '18px', laptop: '32px' }}>
    {isTitleNoteVisible ? (
      <Stack
        w="full"
        justify="space-between"
        align={{ mobile: 'start', xl: 'center' }}
        direction={{ mobile: 'column', xl: 'row' }}
        gap="12px"
      >
        <Text as="h3">{title}</Text>

        <InterText
          color="ourGrayTwo"
          textStyle="b4"
          fontSize={{ mobile: '14px', tablet: '16px', laptop: '18px' }}
          fontWeight="400"
        >
          * - поля, обязательные для заполнения
        </InterText>
      </Stack>
    ) : (
      <Text as="h3">{title}</Text>
    )}

    <Grid
      w="full"
      rowGap={{ mobile: '32px', laptop: '32px' }}
      columnGap="18px"
      templateColumns={{ mobile: '1fr', xt: '1fr 1fr' }}
      {...gridContainerProps}
    >
      <ControllerInput inputsDataArray={inputsData} control={control} trigger={trigger} />
    </Grid>
  </VStack>
);

export default memo(ContactFormSection);
